<div class="py-5 vh-100 d-flex justify-content-center align-items-center">
  <div class="container">
    <img
      src="assets/images/bgs/401.png"
      class="img-fluid d-block mx-auto col-12 col-md-4"
      alt="401"
    />
    <h2
      translate="not_signed"
      class="text-align-center fw-600 text-primary"
    ></h2>
    <p
      translate="not_signed_description"
      class="text-align-center fs-6 text-info"
    ></p>

    <button
      type="button"
      [routerLink]="['/auth']"
      class="btn btn-primary text-white d-block mx-auto mt-4 rounded-8 px-4 py-2 text-capitalize"
      translate="return_home"
    ></button>
  </div>
</div>
